// extracted by mini-css-extract-plugin
export default {"CandidateResumeEducation__content":"WocTu","CandidateResumeEducation__card":"YmuTQ"};